export const NUMBER_TYPE = {
    SMS : 'SMS',
    WHATSAPP : 'WHATSAPP',
    BOTH : 'BOTH'
}